import React from 'react'
import FontFile from '../shared/font-file'


// .09 Autograph — refresh replacement for the old `signature` slot
// The old signature component is intentionally left untouched.
const Word = (props) => {
  return <FontFile
    font={'autograph'}
    topOffset={'0.05em'}
    multiplier={1.25}
    {...props}

    emojiMultiplier={0.7}
  />
}

export default Word
